import React from 'react';

import { utilities } from 'core/use-cases';

const { IntlProvider, useSelector } = utilities;

// TODO: refactor this component to get only "app" and "settings" from state and not the whole state

export function Intl({ children }: { children: React.ReactNode }) {
  const { app, settings } = useSelector((state) => state);

  return (
    <IntlProvider defaultLocale="pt" locale={app.i18n.locale} messages={settings.data.messages}>
      {children}
    </IntlProvider>
  );
}
